'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-text--light, .varta-text--light h1, .varta-text--light h2, .varta-text--light h3, .varta-text--light h4, .varta-text--light h5 {\n  fill: #fff;\n  color: #fff; }\n";
styleInject_es(css_248z);
